<template>
  <div class="row px-4 sizer">
    <div class="col-12" style="padding: 0">
      <Form />
    </div>
  </div>
</template>

<script>
// import Ibox from '@/components/Ibox'
import Form from '@/components/VNFR/Products/Form'
// import MainData from '@/components/VNFR/Products/Forms/MainData.vue'

// import BaseDismiss from '@/components/Comparison/Dismiss'

export default {
  name: 'BaseAdd',
  data() {
    return {
      title_edit: 'Edycja produktu',
      title_dismiss: 'Usuń bazę'
    }
  },
  methods: {
    updateTitle( event ) {
      this.title_edit = event
    }
  },
  components: {
    // Ibox,
    Form
    // MainData
    // BaseDismiss
  }
}
</script>

<style>
.sizer {
  font-size: 14px !important;
}
input[type="radio"], input[type="checkbox"] {
  width: 15px;
  height: 15px;
}
.container {
  max-width: 1320px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
